<template>
  <v-col style="position: relative;">
    <!-- <div class="home-bg" v-if="!$root.siteSettings.registrationMode" /> -->
    <v-row no-gutters class="ma-0 pb-16 mx-n3" align="start" justify="center" v-if="!$root.siteSettings.countdownEnabled" style="position: relative;">
      <v-col cols="12"  md="10"  lg="8" class="mb-16">
        <v-row no-gutters align="center" justify="center">
          <v-col cols="auto">
            <v-img :src="require('@/assets/img/logo-uccello.png').default" width="35vh" height="35vh" contain />
          </v-col>
        </v-row>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="auto" class="text-center text-h3 text-md-h1 text-uppercase">
            IF!Live
          </v-col>
        </v-row>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="auto" class="text-center text-body-1">
            Benvenuti a IF!2021.<br />Per seguire le dirette streaming delle sale IF!HUB e IF!ARENA clicca qui sotto
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mb-16">
        <v-row no-gutters justify="center" v-if="$root.siteSettings.ticketSpendingEnabled && (!$root.databaseUser.spentTickets || ($root.databaseUser.spentTickets.length === 0))" style="background-color: #02a3f0;">
          <v-col cols="12" md="6">
            <mail-ticket-form style="" class="mx-auto" />
          </v-col>
        </v-row>
        <!-- <template v-if="$root.databaseUser.spentTickets && $root.databaseUser.spentTickets.length > 0"> -->
        <div v-if="Rooms" class="rooms-container py-16">
          <v-row no-gutters align="center" justify="center" v-for="room in Rooms.items" :key="room.id" class="px-8" style="position: relative;">
            <room-card :room="room" @playing="onRoomRequestActivation" :playing="roomPlayState[room.id]" />
          </v-row>
        </div>
        <div v-else-if="$apolloData.queries.Rooms.loading">
          <v-responsive :aspect-ratio="16/9">
            <v-row align="center" justify="center" class="fill-height">
                <v-progress-circular class="col col-auto"  indeterminate />
            </v-row>
          </v-responsive>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="$root.siteSettings.countdownEnabled" class="mb-12">
      <v-col cols="12" offset="0" md="10" offset-md="1" lg="8" offset-lg="2">
        <!-- registration mode, no live streams -->
        <div class="text-center" >
          <v-row align="center" justify="center">
            <v-col cols="auto">
              <v-img :src="require('@/assets/img/logo-uccello.png').default" width="35vh" height="35vh" contain />
            </v-col>
          </v-row>
          <v-row v-if="$root.siteSettings.eventStartDate" class="mb-8">
            <v-col>
              <h1 class="text-center text-h2 text-md-h1 mb-16">IF!<span class="bigger-number">2021</span> sta arrivando!</h1>
              <p class="text-center">Il festival avrà inizio in</p>
              <v-row class="flex-nowrap mx-auto" style="max-width: 600px;">
                <v-col class="text-center"><span class="text-h1 d-block mb-4">{{getCountdown(new Date($root.siteSettings.liveStreamStartTime)).days}}</span><span class="d-block">Days</span></v-col>
                <v-col class="text-center"><span class="text-h1 d-block mb-4 lateral-borders">{{getCountdown(new Date($root.siteSettings.liveStreamStartTime)).hours}}</span><span class="d-block">Hours</span></v-col>
                <v-col class="text-center"><span class="text-h1 d-block mb-4">{{getCountdown(new Date($root.siteSettings.liveStreamStartTime)).minutes}}</span><span class="d-block">Minutes</span></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-center mb-6" v-if="!hasValidSpentTicket"><a href="https://www.mailticket.it/manifestazione/E931" class="text-decoration-none" rel="nofollow" target="_blank">Ricordati che per seguire il live del 12 e del 13 novembre è necessario acquistare il 2 days digital pass <span class="text-decoration-underline blue--text text--lighten-4">qui.</span></a></div>
              <template v-if="$root.siteSettings.workshopsEnabled">
                <div class="text-center mb-4">Registrati ai nostri workshop gratuiti.</div>
                <v-btn depressed light rounded large class="px-16 mb-6" :to="{name: 'WorkshopsList'}">Workshops &amp; More</v-btn>
              </template>

              <template v-if="$root.siteSettings.ticketSpendingEnabled && !hasValidSpentTicket">
                <!-- show only if user has not spent tickets -->
                <v-divider style="border-top-width: 2px;
                                  max-width: 800px;" class="my-16 mx-auto"
                                  />
                <mail-ticket-form style="max-width: 800px;" class="mx-auto" />
                <v-divider style="border-top-width: 2px;
                                  max-width: 800px;" class="my-16 mx-auto"
                                  />
              </template>

              <div class="text-center text-h5" v-if="$root.siteSettings.registrationMode">In attesa dell'inizio del festival, guarda i contenuti 2020.</div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="mb-12">
      <v-col cols="auto">
        <v-btn fab depressed dark color="blue darken-3" style="pointer-events: none;"><v-icon x-large>mdi-chevron-down</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-sheet class="mx-n3 py-16 content-sheet" rounded="lg">
      <div class="content-sheet-content">
        <v-row v-if="!$root.siteSettings.registrationMode" style="position: relative;
  z-index: 1;">
          <v-col cols="12" offset="0" md="11" offset-md="1" lg="10" offset-lg="2">
            <FavoritesEvents gallery />
          </v-col>
        </v-row>
        <v-row v-if="!$root.siteSettings.registrationMode" style="position: relative;
  z-index: 1;">
          <v-col cols="12" offset="0" md="11" offset-md="1" lg="10" offset-lg="2">
            <SuggestedEvents gallery />
          </v-col>
        </v-row>
        <v-row style="position: relative;
  z-index: 1;">
          <v-col cols="12" offset="0" md="11" offset-md="1" lg="10" offset-lg="2">
            <PastEvents  />
          </v-col>
        </v-row>
      </div>
    </v-sheet>
  </v-col>
</template>
<script>
import getVideoId from 'get-video-id'
import SuggestedEvents from '@/organisms/SuggestedEvents'
import FavoritesEvents from '@/organisms/FavoritesEvents'
import PastEvents from '@/organisms/PastEvents'
import ListTalk from '@/graphql/ListTalk.gql'
import ListRoom from '@/graphql/ListRoom.gql'
import find from 'lodash/find'
import { delay } from 'lodash'
import { optimizedImageURL, getMetaData, getAspectRatio } from '@/services/OptimizedImage'
import { Viewport } from '@monogrid/vue-lib'
// import LogoMeraviglioso from '@/assets/img/logo-meraviglioso.svg'
import RoomCard from '@/molecules/RoomCard.vue'
import MailTicketForm from '@/organisms/MailTicketForm.vue'
import findIndex from 'lodash/findIndex'
import { userHasRequestedACL, EDITOR_ACL } from '@/services/AuthLevel'

// import VuePlyr from 'vue-plyr'
// import 'plyr/dist/plyr.css'

export default {
  name: 'RegisteredLandingPage',
  mixins: [Viewport],
  components: {
    SuggestedEvents,
    PastEvents,
    FavoritesEvents,
    // LogoMeraviglioso,
    RoomCard,
    MailTicketForm
    // VuePlyr
  },
  mounted () {
    this.clockActive = true
    delay(this.clock, 1000)
  },
  data () {
    return {
      now: this.$root.getNow(),
      roomPlayState: {}
    }
  },
  apollo: {
    Talks: { // Today's talks
      query: ListTalk,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'startingAt',
          descending: false
        }
      },
      result () {
        this.$root.$emit('scroll-to-saved-position')
      }
    },
    Rooms: {
      query: ListRoom,
      skip () {
        return this.$root.siteSettings.registrationMode || !this.hasValidSpentTicket
      },
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'priority',
          descending: true
        }
      },
      result () {
        this.Rooms.items.forEach(room => {
          this.$set(this.roomPlayState, room.id, false)
        })
      }
    }
  },
  computed: {
    hasValidSpentTicket () {
      if (userHasRequestedACL(this.$root.auth.loggedUser, EDITOR_ACL)) {
        return true
      }
      return this.$root.databaseUser &&
        this.$root.databaseUser.spentTickets &&
        Array.isArray(this.$root.databaseUser.spentTickets) &&
        findIndex(this.$root.databaseUser.spentTickets, (t) => t.indexOf('E931') === 0) !== -1
    },
    talkToShow () {
      return this.currentlyStreamingTalk || this.upNextTalk
    },
    upNextTalk () {
      if (!this.Talks) return null
      const now = this.$root.getNow().getTime()
      return find(this.Talks.items, (talk) => {
        const start = new Date(talk.startingAt).getTime()
        return now < start
      })
    },
    currentlyStreamingTalk () {
      if (!this.Talks) return null
      const now = this.$root.getNow().getTime()
      return find(this.Talks.items, (talk) => {
        const start = new Date(talk.startingAt).getTime()
        const end = new Date(talk.endingAt).getTime()
        return now >= start && now < end
      })
    }
  },
  methods: {
    optimizedImageURL,
    getMetaData,
    getAspectRatio,
    getVideoId,
    onRoomRequestActivation (id) {
      this.Rooms.items.forEach(room => {
        this.roomPlayState[room.id] = false
      })
      this.roomPlayState[id] = true
    },
    clock () {
      this.now = this.$root.getNow()
      if (this.clockActive) {
        delay(this.clock, 1000)
      }
    },

    getCountdown (futureTime) {
      // get total seconds between the times
      let delta = Math.abs(futureTime.getTime() - this.now.getTime()) / 1000

      // calculate (and subtract) whole days
      const days = Math.floor(delta / 86400)
      delta -= days * 86400

      // calculate (and subtract) whole hours
      const hours = Math.floor(delta / 3600) % 24
      delta -= hours * 3600

      // calculate (and subtract) whole minutes
      const minutes = Math.floor(delta / 60) % 60
      delta -= minutes * 60

      // what's left is seconds
      const seconds = Math.floor(delta % 60) // in theory the modulus is not required

      return {
        days,
        hours,
        minutes,
        seconds
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-anim {
  position: relative;
  width: 2px;
  height: 30px;
  margin: 4px auto;
  background-color: #1b655d;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    animation: scroll 2s forwards infinite;
  }
}

@keyframes scroll {
  0% {
    transform: translate3d(0, -100%, 0);
  }

  100% {
    transform: translate3d(0, 100%, 0);
  }
}

.v-application .content-sheet {
  background-color: transparent !important;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    background: linear-gradient(90deg, #002131, transparent);
    top: 0;
    left: -70%;
    height: 200%;
    width: 100%;
    border-radius: 800px;
    border: 100px solid #0673b2;
  }

  .content-sheet-content {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      background-image: url('../assets/img/uccello.png');
      background-size: 100% 100%;
      top: 55%;
      left: 0;
      width: 30vw;
      height: 30vw;
      transform: scaleX(-1);
    }

    &::after {
      content: '';
      position: absolute;
      background-image: url('../assets/img/nuvola.png');
      background-size: 100% 100%;
      top: 0;
      right: 0;
      width: 30vw;
      height: 30vw;
      transform: translateY(-20%);
      z-index: 0;
    }
  }
}

.bigger-number {
  font-size: 1.4em;
}

.lateral-borders {
  border-left: 3px solid rgba(#fff, 0.5);
  border-right: 3px solid rgba(#fff, 0.5);
}

// .home-bg {
//   background:
//     url('../assets/img/home.png') no-repeat,
//     url('../assets/img/home-end.png') repeat-y,
//     url('../assets/img/gradient-blue.png') repeat-y,
//     linear-gradient(#0092d0 60%, #0092d0);

//   background-size: 100% auto;
//   background-position: 0 0;
//   height: 100%;
//   width: 100%;
//   position: absolute;
//   top: 0;
//   left: 0;

//   @include breakpoint('xs-only') {
//     background-size: 260% auto;
//     background-position: 82% 0;
//   }
// }

// .home-logo {
//   position: absolute;
//   top: 50vh;
//   left: 50%;
//   height: 70vh;
//   width: 70vh;
//   transform: translate(-50%, -50%);

//   img {
//     width: 100%;
//     height: 100%;
//   }
// }

.rooms-container {
  background-image: url('../assets/img/rooms-bg.png');
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
